import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import './commonClass.css';
import Header from './components/layouts/Header';
import Footer from './components/layouts/Footer';
import Sidebar from './components/layouts/Sidebar';
import { mainRoutes } from './routes/AppRoutes';
import { useSelector } from 'react-redux';

function App() {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const generateRoute = ({ isGuarded, ...route }, key) => {
    if (isGuarded) {
      return (
        <Route
          key={key}
          {...route}
          exact
          element={
            <RequireAuth isLoggedIn={isLoggedIn}>{route.element}</RequireAuth>
          }
        />
      );
    }
    return (
      <Route
        exact
        key={key}
        path={route.path}
        element={isLoggedIn ? <Navigate to="/" replace /> : route.element}
      />
    );
  };
  window.scrollTo(0, 0); //for demo
  return (
    <div className={isLoggedIn === true ? 'px-4 pb-4 bg-white' : ''}>
      {isLoggedIn === true ? <Header /> : ''}
      <div className={isLoggedIn === true ? 'flex widthcals md:pl-32' : ''}>
        {isLoggedIn === true ? <Sidebar /> : ''}
        <div
          className={
            isLoggedIn === true
              ? 'min-w-full xl:min-w-[auto] w-full md:pl-4'
              : ''
          }
        >
          <Routes>
            {mainRoutes.map((route, index) => generateRoute(route, index))}
          </Routes>
          <Footer />
        </div>
      </div>
    </div>
  );
}

const RequireAuth = ({ children, isLoggedIn }) => {
  if (!isLoggedIn) return <Navigate to="/login" replace />;

  return children;
};

export default App;
